<template>
  <v-form ref="form" autocomplete="off">
    <!-- ================= FORMULARIO ================= -->
    <v-row>
      <!-- Descripción Campo -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.DescColumna"
          label="Descripción Campo:"
          clearable
          dense
          maxlength="20"
          counter="20"
          type="text"
          hint="Digite Información"
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-col>

      <!-- Repetición -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Repeticion"
          label="Repetición:"
          clearable
          dense
          maxlength="20"
          counter="20"
          type="text"
          hint="Digite Información"
        >
        </v-text-field>
      </v-col>

      <!-- Naturaleza  -->
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="editedItem.Naturaleza"
          :items="ArrayNaturaleza"
          :item-title="
            (ArrayNaturaleza) => ArrayNaturaleza.Valor + '-' + ArrayNaturaleza.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Naturaleza:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Tipo Información -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.TipoInformacion"
          :items="ArrayTipoInformacion"
          :item-title="
            (ArrayTipoInformacion) =>
              ArrayTipoInformacion.Valor + '-' + ArrayTipoInformacion.Descripcion
          "
          @update:modelValue="ChangeTipoInformacion()"
          item-value="Valor"
          color="primary"
          label="Tipo de Información:"
          dense
          clearable
          :rules="[rules.required]"
        >
        </v-autocomplete>
      </v-col>

      <!-- Número Predefinida -->
      <v-col
        v-if="editedItem.TipoInformacion == TipoDetalleDocumentos.Predefinida"
        cols="12"
        sm="6"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.NumeroPredefinido"
          :items="ArrayPredefinida"
          :item-title="
            (ArrayPredefinida) =>
              ArrayPredefinida.Valor + '-' + ArrayPredefinida.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Número Predefinida:"
          dense
          clearable
          :rules="
            editedItem.TipoInformacion == TipoDetalleDocumentos.Predefinida
              ? [rules.required]
              : []
          "
        >
        </v-autocomplete>
      </v-col>

      <!-- Llave -->
      <v-col
        v-if="editedItem.TipoInformacion == TipoDetalleDocumentos.LLave"
        cols="12"
        sm="6"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.Llave"
          :items="ArrayLLaves"
          :item-title="(ArrayLLaves) => ArrayLLaves.Valor + '-' + ArrayLLaves.Descripcion"
          item-value="Valor"
          color="primary"
          label="Llave:"
          dense
          clearable
          :rules="
            editedItem.TipoInformacion == TipoDetalleDocumentos.LLave
              ? [rules.required]
              : []
          "
        >
        </v-autocomplete>
      </v-col>

      <!-- Reporte -->
      <v-col
        v-if="editedItem.TipoInformacion == TipoDetalleDocumentos.Reporte"
        cols="12"
        sm="6"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.ReporteID"
          :items="ArrayReporteID"
          :item-title="
            (ArrayReporteID) =>
              ArrayReporteID.ReporteID + '-' + ArrayReporteID.NombreReporte
          "
          item-value="ReporteID"
          color="primary"
          label="Reporte:"
          dense
          :rules="
            editedItem.TipoInformacion == TipoDetalleDocumentos.Reporte
              ? [rules.required]
              : []
          "
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Orden Reporte -->
      <v-col
        v-if="editedItem.TipoInformacion == TipoDetalleDocumentos.Reporte"
        cols="12"
        sm="6"
        md="6"
      >
        <v-text-field
          v-model="editedItem.Orden"
          label="Orden Reporte:"
          clearable
          dense
          maxlength="3"
          counter="3"
          type="tel"
          v-on:keypress="isNumber()"
          :rules="
            editedItem.TipoInformacion == TipoDetalleDocumentos.Reporte
              ? [rules.required]
              : []
          "
        >
        </v-text-field>
      </v-col>

      <!-- Rutina -->
      <v-col
        v-if="editedItem.TipoInformacion == TipoDetalleDocumentos.ServicioRutina"
        cols="12"
        sm="6"
        md="6"
      >
        <v-text-field
          v-model="editedItem.Rutina"
          label="Rutina:"
          clearable
          dense
          maxlength="50"
          counter="50"
          type="text"
          hint="Digite Información"
        >
        </v-text-field>
      </v-col>

      <!-- Formato  -->
      <v-col cols="12" md="6" sm="6">
        <v-autocomplete
          v-model="editedItem.Formato"
          :items="ArrayFormato"
          :item-title="
            (ArrayFormato) => ArrayFormato.Valor + ' - ' + ArrayFormato.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Formato:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Adicionar -->
      <v-col cols="12" md="2">
        <v-btn color="blue" @click="adicionarProceso"> Adicionar </v-btn>
      </v-col>
    </v-row>

    <div align="right" class="mb-6">
      <v-btn color="green" @click="ValidateCampos"> Guardar </v-btn>
    </div>

    <!-- ================= TABLA DRAG ================= -->

    <v-card>
      <v-card>
        <v-card-title> Tabla Detalle Documentos</v-card-title>

        <v-table height="550px">
          <thead>
            <tr>
              <th style="width: 40px"></th>
              <th style="width: 80px">Acciones</th>
              <th style="width: 40px">Secuencia</th>
              <th>Descripción</th>
              <th>¿Tipo Tabla?</th>
              <th>Tipo de Información</th>
              <th>Naturaleza</th>
              <th>Predefinida // Llave // Reporte</th>
              <th>Formato</th>
            </tr>
          </thead>

          <draggable
            v-model="items"
            tag="tbody"
            item-key="Dato"
            handle=".drag-handle"
            animation="200"
            @end="guardarOrden"
          >
            <template #item="{ element }">
              <tr>
                <td class="drag-handle">☰</td>
                <td>
                  <v-icon color="red" @click="eliminarFila(element)">mdi-delete</v-icon>
                </td>
                <td>{{ element.Secuencia }}</td>
                <td>{{ element.DescColumna }}</td>
                <td>
                  {{ element.Repeticion }}
                </td>
                <td>{{ element.DescTipoInformacion }}</td>
                <td>{{ element.DescNaturaleza }}</td>
                <td>
                  {{
                    TipoDetalleDocumentos.LLave == element.TipoInformacion
                      ? element.DescLlave
                      : TipoDetalleDocumentos.Reporte == element.TipoInformacion
                      ? element.DescReporteID + " Número Columna: " + element.Orden
                      : TipoDetalleDocumentos.Predefinida == element.TipoInformacion
                      ? element.DescPredefinida
                      : ""
                  }}
                </td>
                <td>
                  {{ element.DescFormato }}
                </td>
              </tr>
            </template>
          </draggable>
        </v-table>
      </v-card>
    </v-card>
  </v-form>

  <!-- ================= PROGRESO ================= -->
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
          </v-toolbar>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {
  Upsert,
  getConsultAll,
} from "@/views/TCI/Documentos/DetalleDocumentos/DetalleDocumentosService";
import { TipoDetalleDocumentos } from "@/views/TCI/Documentos/Constantes/ConstantesDocumentos";
import { TablaSeleccion } from "@/views/TCI/Seguridad/Constantes/ConstantesSeguridad";

export default {
  name: "dato-calculado",

  props: {
    info: {
      type: Object,
      default: null,
      Description: "Información de datos",
    },
  },

  components: {
    draggable,
  },

  data() {
    return {
      TipoDetalleDocumentos,
      TablaSeleccion,
      progreso: false,
      documentoId: null,
      editedItem: {
        DescColumna: null,
        Repeticion: null,
        NombreHoja: null,
        TipoInformacion: null,
        NumeroPredefinido: null,
        Naturaleza: null,
        Llave: null,
        ReporteID: null,
        Orden: null,
        Rutina: null,
        Formato: null,
      },

      modelfiltro: [
        {
          campo: "DocumentoID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Dato:",
        },
      ],

      ArrayPredefinida: [],
      ArrayLLaves: [],
      ArrayTipoInformacion: [],
      ArrayNaturaleza: [],
      ArrayReporteID: [],
      ArrayFormato: [],
      items: [],
      itemsEliminados: [],
      rules: {
        required: (v) => !!v || "Campo obligatorio",
      },
    };
  },

  methods: {
    async ValidateCampos() {
      if (this.items.length === 0) {
        this.$swal({
          icon: "warning",
          title: "No hay procesos para guardar",
        });
        return;
      }

      this.progreso = true;

      try {
        const dataGuardar = [
          ...this.items.map((item) => ({
            ...item,
            Eliminar: false,
          })),
          ...this.itemsEliminados,
        ];

        await Upsert(dataGuardar);

        this.$swal({
          icon: "success",
          title: "Guardado correctamente",
        });

        this.itemsEliminados = [];
        this.getConsultData();
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Consulta Tablero
    async getConsultData() {
      this.items = [];
      this.progreso = true;
      this.modelfiltro[0].contenido = this.documentoId;
      this.modelfiltro[0].filtro = "=";
      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: true,
      };
      try {
        const result = await getConsultAll(data);

        // Guardamos el orden original
        this.items = result.map((item) => ({
          ...item,
          OrdenOriginal: item.Secuencia,
          EsNuevo: false, // bandera para nuevos
        }));
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
        this.dialogframe = false;
      }
    },

    guardarOrden() {
      this.reorganizarSecuencia();
      console.log("Nuevo orden:", this.items);
    },

    eliminarFila(item) {
      this.$swal({
        title: "¿Eliminar registro?",
        text: "Esta acción eliminará la fila seleccionada.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.isConfirmed) return;

        // Si ya existe en BD, lo guardamos para eliminar en backend
        if (!item.EsNuevo) {
          this.itemsEliminados.push({
            TipoInformacion: item.TipoInformacion,
            DocumentoID: item.DocumentoID,
            Secuencia: item.Secuencia,
            DescColumna: item.DescColumna,
            OrdenOriginal: item.OrdenOriginal,
            Eliminar: true,
          });
        }

        // Se elimina de memoria
        this.items = this.items.filter((x) => x !== item);

        // Reorganizar secuencia
        this.reorganizarSecuencia();
      });
    },

    reorganizarSecuencia() {
      this.items.forEach((item, index) => {
        item.Secuencia = index + 1;
      });
    },

    reset() {
      var tabla = this.$store.getters.MTablaSeleccion;

      // Array tipo de información
      this.ArrayTipoInformacion = tabla.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.TipoInformacion
      );

      // Array Predefinida
      this.ArrayPredefinida = tabla.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.Predefinida
      );

      // Array LLaves
      this.ArrayLLaves = tabla.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.LLaves
      );

      // Array Naturaleza
      this.ArrayNaturaleza = tabla.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.Naturaleza
      );

      // Array Formato
      this.ArrayFormato = tabla.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.Formato
      );

      this.ArrayReporteID = this.$store.getters.MReporte;
    },

    async adicionarProceso() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
        return;
      }

      // Buscar el proceso completo en el array Tipo Informacion
      const constSeleccionado1 = this.ArrayTipoInformacion.find(
        (p) => p.Valor == this.editedItem.TipoInformacion
      );

      // Buscar el proceso completo en el array Predefinida
      const constSeleccionado2 = this.ArrayPredefinida.find(
        (p) => p.Valor == this.editedItem.NumeroPredefinido
      );

      // Buscar el proceso completo en el array Llave
      const tipoSeleccionado1 = this.ArrayLLaves.find(
        (p) => p.Valor == this.editedItem.Llave
      );

      // Buscar el proceso completo en el array Naturaleza
      const tipoSeleccionado2 = this.ArrayNaturaleza.find(
        (p) => p.Valor == this.editedItem.Naturaleza
      );

      // Buscar el proceso completo en el array ReporteID
      const reporte = this.ArrayReporteID.find(
        (p) => p.ReporteID == this.editedItem.ReporteID
      );

      // Buscar el proceso completo en el array Formato
      const tipoSeleccionado3 = this.ArrayFormato.find(
        (p) => p.Valor == this.editedItem.Formato
      );

      var userperfil = this.$store.getters.userperfil;

      // Agregar a la tabla
      this.items.push({
        DocumentoID: this.documentoId,
        Secuencia: this.items.length + 1,
        DescColumna: this.editedItem.DescColumna,
        Repeticion: this.editedItem.Repeticion,
        NombreHoja: this.editedItem.NombreHoja,
        TipoInformacion: this.editedItem.TipoInformacion,
        DescTipoInformacion: constSeleccionado1 ? constSeleccionado1.Descripcion : "",
        Naturaleza: this.editedItem.Naturaleza,
        DescNaturaleza: tipoSeleccionado2 ? tipoSeleccionado2.Descripcion : "",
        NumeroPredefinido: this.editedItem.NumeroPredefinido,
        DescPredefinida: constSeleccionado2 ? constSeleccionado2.Descripcion : "",
        Llave: this.editedItem.Llave,
        DescLlave: tipoSeleccionado1 ? tipoSeleccionado1.Descripcion : "",
        ReporteID: this.editedItem.ReporteID,
        DescReporteID: reporte ? reporte.NombreReporte : "",
        Orden: this.editedItem.Orden,
        Rutina: this.editedItem.Rutina,
        Formato: this.editedItem.Formato,
        DescFormato: tipoSeleccionado3 ? tipoSeleccionado3.Descripcion : "",
        UsuarioCreacion: userperfil.userInfo.Usuario_ID,
        UsuarioActualizacion: userperfil.userInfo.Usuario_ID,
        OrdenOriginal: null, // no tiene orden original
        EsNuevo: true, // es nuevo
      });

      // Limpiar selección
      this.editedItem.TipoInformacion = null;
      this.editedItem.NumeroPredefinido = null;
      this.editedItem.Llave = null;
      this.editedItem.ReporteID = null;
      this.editedItem.Orden = null;
      this.editedItem.Rutina = null;
      this.editedItem.Naturaleza = null;
      this.editedItem.Repeticion = null;
      this.editedItem.NombreHoja = null;
      this.editedItem.DescColumna = null;
      this.editedItem.Formato = null;
    },

    // Change Tipo Información
    ChangeTipoInformacion() {
      this.editedItem.NumeroPredefinido = null;
      this.editedItem.Llave = null;
      this.editedItem.ReporteID = null;
      this.editedItem.Orden = null;
      this.editedItem.Rutina = null;
    },
  },

  mounted() {
    if (this.info) {
      this.documentoId = this.info.DocumentoID;
    }

    this.reset();
    this.getConsultData();
  },
};
</script>

<style>
.drag-handle {
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}
</style>
